export const parseJsonSilently = jsonString => {
  try {
    const parsed = JSON.parse(jsonString);
    return parsed ?? {};
  } catch (_e) {
    return {};
  }
};

export const stringifyJsonSilently = obj => {
  try {
    return JSON.stringify(obj);
  } catch (_e) {
    return "";
  }
};
